//# sourceMappingURL=project.mjs.map
/// <reference types="./project.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $endpoints from "../../../altar/altar/endpoints.mjs";
import * as $page from "../../../data_types/data/page.mjs";
import * as $project from "../../../data_types/data/project.mjs";
import * as $project_file from "../../../data_types/data/project_file.mjs";
import * as $global from "../../../ds/web/javascript/global.mjs";
import * as $fetch from "../../../gleam_fetch/gleam/fetch.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $request from "../../../gleam_http/gleam/http/request.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $uri from "../../../gleam_stdlib/gleam/uri.mjs";
import * as $file from "../../../magellan/magellan/file.mjs";
import * as $mime_types from "../../../mime_types/mime_types.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $super_admin from "../../admin/effects/super_admin.mjs";
import { apply_org_header, super_admin_org_header } from "../../admin/effects/super_admin.mjs";
import * as $error from "../../admin/error.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, toList, makeError } from "../../gleam.mjs";

const FILEPATH = "src/admin/effects/project.gleam";

export function fetch_projects(page_index) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(new $ask.Admin(), toList(["projects"]));
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = apply_org_header(_pipe$1, store);
          let _pipe$3 = $ask.query(
            _pipe$2,
            "page_index",
            $int.to_string(page_index),
          );
          let _pipe$4 = $ask.query(
            _pipe$3,
            "page_size",
            $int.to_string($page.default_page_size),
          );
          let _pipe$5 = $ask.expect(
            _pipe$4,
            $page.page_decoder($decode.list($project.decoder())),
          );
          let _pipe$6 = $ask.on_success(
            _pipe$5,
            (pagination) => {
              let _pipe$6 = pagination;
              let _pipe$7 = new $msg.ApiReturnedProjects(_pipe$6);
              let _pipe$8 = new $msg.Project(_pipe$7);
              return dispatch(_pipe$8);
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}

/**
 * TODO Should probably be authorized for super-admins.
 */
export function fetch_project_file(project_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["projects", project_id, "files"]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = $ask.via(_pipe$1, new $http.Get());
          let _pipe$3 = apply_org_header(_pipe$2, store);
          let _pipe$4 = $ask.expect(
            _pipe$3,
            $decode.list($project_file.file_decoder()),
          );
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (p) => {
              let _pipe$5 = new $msg.ApiReturnedProjectsFile(p, project_id);
              let _pipe$6 = new $msg.Project(_pipe$5);
              return dispatch(_pipe$6);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

function download_file(archive, project_file) {
  let _pipe = $file.download(project_file.name, archive);
  return $promise.map(_pipe, (_) => { return new Ok(undefined); });
}

export function download_project_file(project_file) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let url = $endpoints.heimdall();
          let url$1 = $string.join(
            toList([
              url,
              "projects",
              project_file.project_id,
              "files",
              project_file.id,
              "download",
            ]),
            "/",
          );
          let $ = $request.to(url$1);
          let request;
          if ($ instanceof Ok) {
            request = $[0];
          } else {
            throw makeError(
              "let_assert",
              FILEPATH,
              "admin/effects/project",
              82,
              "download_project_file",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $,
                start: 2334,
                end: 2374,
                pattern_start: 2345,
                pattern_end: 2356
              }
            )
          }
          let _pipe = request;
          let _pipe$1 = $request.set_method(_pipe, new $http.Get());
          let _pipe$2 = $request.set_header(
            _pipe$1,
            "authorization",
            "Bearer " + access_token,
          );
          let _block;
          let $1 = store.organization;
          if ($1 instanceof Some) {
            let org_id = $1[0];
            _block = (_capture) => {
              return $request.set_header(
                _capture,
                super_admin_org_header,
                org_id,
              );
            };
          } else {
            _block = $function.identity;
          }
          let _pipe$3 = _block(_pipe$2);
          let _pipe$4 = $fetch.send(_pipe$3);
          let _pipe$5 = $promise.try_await(_pipe$4, $fetch.read_bytes_body);
          let _pipe$6 = $promise.map(
            _pipe$5,
            (_capture) => {
              return $result.map_error(
                _capture,
                (var0) => { return new $error.FetchError(var0); },
              );
            },
          );
          let _pipe$7 = $promise.map_try(
            _pipe$6,
            (response) => {
              return $error.internal_error(
                response,
                "Error while exporting project",
              );
            },
          );
          let _pipe$8 = $promise.map_try(
            _pipe$7,
            (res) => { return new Ok(res.body); },
          );
          let _pipe$9 = $promise.try_await(
            _pipe$8,
            (_capture) => { return download_file(_capture, project_file); },
          );
          return $promise.map(
            _pipe$9,
            (response) => {
              return $global.set_timeout(
                1000,
                () => {
                  let _block$1;
                  if (response instanceof Ok) {
                    let _pipe$10 = "File downloaded successfully!";
                    _block$1 = ((_capture) => {
                      return new $msg.ApplicationRequestedToDisplayToast(
                        new $toast.Success(),
                        _capture,
                      );
                    })(_pipe$10);
                  } else {
                    let _pipe$10 = "Unable to download the file. Please try again later.";
                    _block$1 = ((_capture) => {
                      return new $msg.ApplicationRequestedToDisplayToast(
                        new $toast.Error(),
                        _capture,
                      );
                    })(_pipe$10);
                  }
                  let _pipe$10 = _block$1;
                  dispatch(_pipe$10);
                  return undefined;
                },
              );
            },
          );
        },
      );
    },
  );
}

export function download_converted_project_file(project_file, mime_type) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let url = $endpoints.heimdall();
          let url$1 = $string.join(
            toList([
              url,
              "projects",
              project_file.project_id,
              "files",
              project_file.id,
              "download",
              "converted",
              (() => {
                let _pipe = $mime_types.to_string(mime_type);
                return $uri.percent_encode(_pipe);
              })(),
            ]),
            "/",
          );
          let $ = $request.to(url$1);
          let request;
          if ($ instanceof Ok) {
            request = $[0];
          } else {
            throw makeError(
              "let_assert",
              FILEPATH,
              "admin/effects/project",
              135,
              "download_converted_project_file",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $,
                start: 3937,
                end: 3977,
                pattern_start: 3948,
                pattern_end: 3959
              }
            )
          }
          let _pipe = request;
          let _pipe$1 = $request.set_method(_pipe, new $http.Get());
          let _pipe$2 = $request.set_header(
            _pipe$1,
            "authorization",
            "Bearer " + access_token,
          );
          let _block;
          let $1 = store.organization;
          if ($1 instanceof Some) {
            let org_id = $1[0];
            _block = (_capture) => {
              return $request.set_header(
                _capture,
                super_admin_org_header,
                org_id,
              );
            };
          } else {
            _block = $function.identity;
          }
          let _pipe$3 = _block(_pipe$2);
          let _pipe$4 = $fetch.send(_pipe$3);
          let _pipe$5 = $promise.try_await(_pipe$4, $fetch.read_bytes_body);
          let _pipe$6 = $promise.map(
            _pipe$5,
            (_capture) => {
              return $result.map_error(
                _capture,
                (var0) => { return new $error.FetchError(var0); },
              );
            },
          );
          let _pipe$7 = $promise.map_try(
            _pipe$6,
            (response) => {
              return $error.internal_error(
                response,
                "Error while exporting project",
              );
            },
          );
          let _pipe$8 = $promise.map_try(
            _pipe$7,
            (res) => { return new Ok(res.body); },
          );
          let _pipe$9 = $promise.try_await(
            _pipe$8,
            (_capture) => { return download_file(_capture, project_file); },
          );
          return $promise.map(
            _pipe$9,
            (response) => {
              return $global.set_timeout(
                1000,
                () => {
                  let _block$1;
                  if (response instanceof Ok) {
                    let _pipe$10 = "File downloaded successfully!";
                    _block$1 = ((_capture) => {
                      return new $msg.ApplicationRequestedToDisplayToast(
                        new $toast.Success(),
                        _capture,
                      );
                    })(_pipe$10);
                  } else {
                    let _pipe$10 = "Unable to download the file. Please try again later.";
                    _block$1 = ((_capture) => {
                      return new $msg.ApplicationRequestedToDisplayToast(
                        new $toast.Error(),
                        _capture,
                      );
                    })(_pipe$10);
                  }
                  let _pipe$10 = _block$1;
                  dispatch(_pipe$10);
                  return undefined;
                },
              );
            },
          );
        },
      );
    },
  );
}
